import React, { forwardRef } from 'react'
import styled from '@emotion/styled'
import { useDispatch, useSelector } from 'react-redux'
import { Accordion } from '@mobi/component-library/Common/V2/Accordion'
import { spacing } from '@mobi/component-library/Theme/Common'
import type { BetSlipItem } from '@mobi/betslip/types'
import {
  selectIsBettingSectionExpanded,
  selectWorkflowStatus,
} from '@mobi/betslip/Store/Workflow/selectors'
import { setBettingSectionExpandedState } from '@mobi/betslip/Store/Workflow'
import { SingleItem } from './Components/SingleItem'
import { filterSingleItemsForWorkflow } from './helpers/filterSingleItemsForWorkflow'
import { useBonusAppliedItems } from '../../hooks/useBonusAppliedItems'

export const Singles = forwardRef<HTMLDivElement, { items: BetSlipItem[] }>(({ items }, ref) => {
  const dispatch = useDispatch()

  const workflowStatus = useSelector(selectWorkflowStatus)
  const isBettingSectionExpanded = useSelector(selectIsBettingSectionExpanded)

  const workflowFilteredItems = filterSingleItemsForWorkflow(items, workflowStatus)

  const { betSlipItems: filteredItems } = useBonusAppliedItems(workflowFilteredItems)

  if (!filteredItems || filteredItems.length === 0) return null

  return (
    <Accordion
      title={`Singles (${filteredItems.length})`}
      isExpandedControlled={isBettingSectionExpanded.Singles}
      shouldStartExpanded={isBettingSectionExpanded.Singles}
      onToggle={isExpandedPrev =>
        dispatch(setBettingSectionExpandedState({ Singles: !isExpandedPrev }))
      }
      shouldUseDefaultTheme={false}
      ref={ref}
    >
      <ListStyled>
        {filteredItems.map(item => (
          <SingleItem key={item.id} item={item} />
        ))}
      </ListStyled>
    </Accordion>
  )
})

Singles.displayName = 'Singles'

// ======
// Styles
// ======

const ListStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.smx1,
  paddingBottom: spacing.smx1,
})
